<script>
  import { onMount } from "svelte";
  import { supportsIntersectionObserver } from "@/utils";
  import * as PropTypes from "prop-types";

  const { checkPropTypes, number } = PropTypes;
  export let threshold;

  let intersectionObserver = null,
    componentToWatch = null,
    visible = false;

  const propTypes = {
    threshold: number,
  };

  onMount(() => {
    checkPropTypes(propTypes, $$props, "prop", "Observer");
    if (supportsIntersectionObserver()) {
      const options = threshold
        ? {
            threshold,
          }
        : null;
      intersectionObserver = new IntersectionObserver(([entry]) => {
        visible = entry.isIntersecting;
      }, options);
      intersectionObserver.observe(componentToWatch);
    }

    return () => intersectionObserver?.disconnect();
  });
</script>

<div class="w-full h-full" bind:this={componentToWatch}>
  <slot {visible} />
</div>
